import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../Components/Button/Button';

const ModalConfirmacion = ({show, onHide, onResolve, data, indicador}) => {
	const [mensajeModal] = useState({ titulo: `¿Estás seguro que deseas cambiar ${indicador ? "el indicador" : "la exigencia"}?`, texto: "se borraran todos los datos guardados previamente" });

    const btnAceptar = () => {
        onResolve(true);
        onHide();
        data(true);
    };

    const btnCancelar = () => {
        onResolve(false);
        onHide();
    };

	return (
		<Modal
			show={show}
			onHide={onHide}
			size="md"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Body>
				<div className='info my-4'>
					<span className='info__icon'>
						<i className='ico-user-delete'></i>
					</span>
					<h6 className='info__title'>{mensajeModal.titulo}</h6>
					<p className='info__text'>{mensajeModal.texto}</p>
				</div>
				<div className="d-flex flex-column flex-md-row justify-content-center align-items-stretch align-items-md-center gap-4">
					<Button type="button" design="btn-outline-pewter-blue btn--small" onClick={btnCancelar}>Cancelar</Button>
					<Button type="button" design="btn-primary btn--small" onClick={btnAceptar}>Aceptar</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}
export default ModalConfirmacion;
